import { atom, selector } from 'recoil';

// Current user info
export const userAtom = atom({
  key: 'user',
  default: null,
});

// Authentication loading state
export const authLoadingAtom = atom({
  key: 'authLoading',
  default: true,
});

// Auth error state
export const authErrorAtom = atom({
  key: 'authError',
  default: null,
});

// Selector for authentication status
export const isAuthenticatedSelector = selector({
  key: 'isAuthenticated',
  get: ({ get }) => {
    const user = get(userAtom);
    return user !== null;
  },
});

// Selector for user display name
export const userDisplayNameSelector = selector({
  key: 'userDisplayName',
  get: ({ get }) => {
    const user = get(userAtom);
    return user?.name || user?.email || 'User';
  },
});

// Selector for checking if user is admin
export const isAdminSelector = selector({
  key: 'isAdmin',
  get: ({ get }) => {
    const user = get(userAtom);
    return user?.role === 'admin';
  },
});

// Selector for user role
export const userRoleSelector = selector({
  key: 'userRole',
  get: ({ get }) => {
    const user = get(userAtom);
    return user?.role || 'manager';
  },
});
